/*
 * @Description  :
 * @Author       : lcs
 * @Date         : 2023-12-22 00:44:11
 * @LastEditors  : luchaoshun@ihaier.com
 * @LastEditTime : 2023-12-28 21:11:51
 */
import action from './action.js'
import { baseUrl } from '../config'
import moment from 'moment'
export default class request {
  static get(address, params) {
    let url = baseUrl + address
    return action.get(url, {
      // params: {
      ...params,
      time_stamp: moment().unix()
      // }
    })
  }

  static post(address, data) {
    let url = baseUrl + address
    return action.post(url, data)
  }

  static upPic(data) {
    let url = baseUrl + '/common/upload'
    return action.upPic(url, data)
  }
}
